import {useRef} from "react";
import {shaderMaterial, useTexture} from "@react-three/drei";
import {extend} from "@react-three/fiber";
import canvasVertexShader from "./shaders/canvas/vertex.glsl";
import canvasFragmentShader from "./shaders/canvas/fragment.glsl";

const CanvasMaterial = shaderMaterial(
    {
        uMask: null,
        uBackground: null,
        uShadow: null,
        uIsProductOnFloor: false,
        uIsProductOnWall: false
    },
    canvasVertexShader,
    canvasFragmentShader
)

extend({ CanvasMaterial })

export default function CanvasMask(props) {
    // Canvas Mask
    const canvasMaterial = useRef();

    const uMask = useTexture(props.mask);
    const uShadow = props.shadow;
    const uBackground = useTexture(props.background);

    return <mesh position={props.position} >
        <planeGeometry args={[props.scale[0], props.scale[1]]} />
        <canvasMaterial
            uMask={uMask}
            uShadow={uShadow}
            uBackground={uBackground}
            uIsProductOnFloor={props.isProductOnFloor}
            uIsProductOnWall={props.isProductOnWall}
            transparent={true}
            ref={canvasMaterial}
        />
    </mesh>
}